import { ISectionType } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class TermSectionType implements ISectionType {
  static build(sectionType: ISectionType) {
    return new TermSectionType(sectionType);
  }
  cd: string;
  course: number;
  id: number;
  is_active: boolean;
  is_required: boolean;
  name: string;
  nk: string;
  rank: number;
  term: number;
  session: string = '-1';

  constructor(sectionType: ISectionType) {
    _4.merge(this, sectionType, {
      name: _4.isEmpty(_4.get(sectionType, 'name', ''))
        ? _4.get(sectionType, 'cd', '')
        : _4.get(sectionType, 'name', ''),
      session: sectionType.session ? sectionType.session : '-1'
    });
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/builders/term_course_section_type_builder.ts